import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Box, Card, Skeleton, Stack, Typography } from "@mui/material";

export const OrderDriverInfoSkeleton = () => {
    return (
        <Card sx={{ width: "100%", borderRadius: "10px", p: 1.5 }}>
            <Box mb={2}>
                <Stack direction={"row"} alignItems={"center"} mb={1}>
                    <LocalShippingIcon
                        sx={{ marginRight: 1 }}
                        color="inherit"
                    />
                    <Typography
                        variant="body2"
                        fontWeight={600}
                        textAlign={"left"}
                    >
                        Driver
                    </Typography>
                </Stack>
                <Skeleton variant="text" />
            </Box>
            <Box mb={2}>
                <Typography
                    mb={1}
                    variant="body2"
                    fontWeight={600}
                    textAlign={"left"}
                >
                    Contact Information
                </Typography>
                <Skeleton variant="text" />
            </Box>
        </Card>
    );
};
